import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { equipmentObject } from './equipment.model';

@Injectable({
  providedIn: 'root',
})
export class AddBodyserialService {
  constructor(
    private httpClient: HttpClient,
    private rootScopeService: RootScopeService,
    private httpHeaderService: HttpHeadersService
  ) { }

  public verifyBodySerial(facilityId: string, bodySerial: string, connectedStrength?: boolean): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    if (connectedStrength) {
      return this.httpClient.post(
        environment.servicePath + '/equipment/assets/validate', { facilityId: facilityId, equipmentSerialNumber: bodySerial },
        { headers }
      );
    }
    return this.httpClient.get(
      environment.servicePath + '/equipment/asset_details?bodySerial=' + bodySerial + '&facilityId=' + facilityId,
      { headers }
    );
  }

  public saveEquipment(bodySerial: string, UUID: string, facilityId: any, connectedStrength?: boolean): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    if (connectedStrength) {
      return this.httpClient.post(environment.servicePath + '/equipment/assets', { facilityId: facilityId, equipmentSerialNumber: bodySerial }, { headers });
    }
    return this.httpClient.put(environment.servicePath + '/equipment/' + UUID, { facilityId: facilityId }, { headers });
  }

  checkGlobalBodySerialFormat(bodySerial: string): boolean {
    let _allowedLocs = [
      'W',
      'R',
      'F',
      'K',
      'T',
      'N',
      'X',
      'M',
      'P',
      'I',
      'D',
      'C',
      'Y',
      'H'
    ];// 14
    let _allowedPLs = [
      '50L',
      '70T',
      'ACT',
      'ADD',
      'C1S',
      'C3S',
      'C5S',
      'CGO',
      'CI1',
      'CM1',
      'CPP',
      'CRS',
      'CSM',
      'CSP',
      'CTR',
      'CVS',
      'CYL',
      'ELV',
      'INT',
      'LFC',
      'MJ1',
      'OP1',
      'OS1',
      'PCS',
      'RSC',
      'S11',
      'S18',
      'S36',
      'S90',
      'SE3',
      'SE4',
      'SLI',
      'SLS',
      'SMS',
      'SPL',
      'SS1',
      'STR',
      'SYN',
      'TC1',
      'A5K',

      'ACC',//Begin Missed out product line.
      'AXB',
      'AXS',
      'C2S',
      'C4S',
      'C7S',
      'CMS',
      'CVC',
      'E7K',
      'FIT',
      'HBR',
      'HBW',
      'HDL',
      'HDR',
      'HDT',
      'HGB',
      'HIL',
      'HIP',
      'HIT',
      'HPL',
      'HSH',
      'HSP',
      'HSS',
      'HST',
      'I1K',
      'I7K',
      'IC1',
      'IC2',
      'IC3',
      'IC4',
      'IC5',
      'IC6',
      'IC7',
      'IC8',
      'ICC',
      'ILL',
      'IOB',
      'IOS',
      'LAT',
      'MJS',
      'MTS',
      'OB1',
      'P1K',
      'P1X',
      'P2X',
      'S1X',
      'SBR',
      'TCS',
      'TVC',//End Missed out product line.

    ]; //39
    let _allowedPMTs = [
      '3HX',
      '3LS',
      '3SS',
      '410',
      '414',
      '420',
      '424',
      '430',
      '434',
      '4WN',
      '4X4',
      '610',
      '614',
      '620',
      '624',
      '630',
      '634',
      '6X4',
      'AB1',
      'ABB',
      'ABC',
      'ACO',
      'ADB',
      'ADC',
      'ADD',
      'ADJ',
      'AP1',
      'AP4',
      'AR1',
      'AR3',
      'ARB',
      'ARC',
      'AXO',
      'B04',
      'B14',
      'B24',
      'BBR',
      'BC1',
      'BE1',
      'BED',
      'BM1',
      'BNK',
      'BRE',
      'BSQ',
      'BT1',
      'BUP',
      'CB1',
      'CC1',
      'CC2',
      'CD1',
      'CDL',
      'CE1',
      'CI1',
      'CLF',
      'CON',
      'COR',
      'CP1',
      'CT1',
      'CV1',
      'DAP',
      'DBV',
      'DCP',
      'DIP',
      'DPH',
      'DPL',
      'DPR',
      'DR1',
      'DR2',
      'DR3',
      'DRW',
      'DWT',
      'ERG',
      'FLY',
      'FMP',
      'FS1',
      'FS4',
      'FS6',
      'FSS',
      'FXO',
      'G2S',
      'G3S',
      'G4S',
      'G5S',
      'G7S',
      'GBB',
      'GCB',
      'GDB',
      'GKB',
      'GL1',
      'GLD',
      'GRP',
      'HAA',
      'HAB',
      'HAD',
      'HAR',
      'HC1',
      'HG1',
      'HL1',
      'HR1',
      'HRH',
      'HRW',
      'IP1',
      'KIO',
      'KLC',
      'LC1',
      'LCE',
      'LE1',
      'LHS',
      'LLP',
      'LPD',
      'LR1',
      'LR2',
      'LR3',
      'LR4',
      'MAB',
      'MBS',
      'OBS',
      'ODB',
      'OFB',
      'OIB',
      'OMB',
      'OSR',
      'OWT',
      'PD1',
      'PEC',
      'PO1',
      'PR1',
      'PSF',
      'PWM',
      'REM',
      'RW1',
      'RWD',
      'RWR',
      'SC1',
      'SCD',
      'SCE',
      'SCN',
      'SH1',
      'SHC',
      'SHP',
      'SLC',
      'SLP',
      'SM1',
      'SMV',
      'SP1',
      'SPC',
      'SQL',
      'STP',
      'STR',
      'STT',
      'STU',
      'STV',
      'TBR',
      'TE1',
      'TIB',
      'TP1',
      'TR1',
      'TRF',
      'TRM',
      'TVA',
      'TWL',
      'TWR',
      'UB1',
      'VC1',
      'VSQ',
      'VV1',
      'WCT',
      'WPD',
      'WSR',
      'XTS',
      'XTU'

    ]; //171
    let _allowedMinYear = 21;
    let _allowedMaxYear = parseInt(new Date().getFullYear().toString().substr(-2));
    let _allowedMaxWeek = 53;
    let _seqNo = 9999;
    const [productLine, productModel, location, year, week, seq] = <string[]>(
      bodySerial.match(/^(.*)(.{3})(.{3})(.{1})(.{2})(.{2})(.{4})/)?.slice(2)
    );
    // checking whether the string has A-Z and 0-9 only followed by PL(3), PMT(3), Location(1), year(2)
    // week(2) 0 - 53 followed by sequence number(4) from 0 - 9999
    if (
      bodySerial.match('^[A-Z0-9]+$') &&
      _allowedPLs.includes(productLine) &&
      _allowedPMTs.includes(productModel) &&
      _allowedLocs.includes(location) &&
      +year >= _allowedMinYear &&
      +year <= _allowedMaxYear &&
      +week > 0 &&
      +week <= _allowedMaxWeek &&
      +seq > 0 &&
      +seq <= _seqNo
    ) {
      return true;
    }
    return false;
  }
}
